import { ISettingsFeatures } from '@/shims-tsx';

type State = {
  settings: {
    isTournamentWinToBetForX: boolean;
    isCanvasOptions: boolean;
  };
};

export default {
  state: {
    settings: {
      isTournamentWinToBetForX: false,
      isCanvasOptions: true
    }
  },
  getters: {
    isTournamentWinToBetForX(state: State) {
      return state.settings.isTournamentWinToBetForX;
    },
    isCanvasOptions(state: State) {
      return state.settings.isCanvasOptions;
    }
  },

  mutations: {
    setSettings(state: State, data: ISettingsFeatures) {
      if (typeof data.isTournamentWinToBetForX === 'boolean') {
        state.settings.isTournamentWinToBetForX = data.isTournamentWinToBetForX;
      }

      if (typeof data.isCanvasOptions === 'boolean') {
        state.settings.isCanvasOptions = data.isCanvasOptions;
      }
    }
  },
  actions: {}
};
